<template>
  <v-autocomplete
    v-model="selectedValues"
    @update:modelValue="doChange"
    :placeholder="'Select A Unit'"
    :multiple="multi"
    :clearable="clearable"
    :items="getUnitList"
    :density="'compact'"
    item-title="name"
    item-value="id"
    @update:menu="toggleMenu"
    :style="displayInline ? 'display:inline' : ''"
  >
    <template v-slot:selection="{ item, index }">
      <v-chip v-if="!maxItems || index < maxItems" :text="item.title"></v-chip>
      <span
        v-if="maxItems && index === maxItems"
        class="text-grey text-caption align-self-center"
      >
        (+{{ selectedValues.length - maxItems }} more)
      </span>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'unitSelect',
  computed: {
    ...mapGetters('units', ['getUnits']),
    getUnitList() {
      if (this.allowAll) {
        return [
          ...this.getUnits,
          {
            name: 0,
            label: this.allLabel ?? 'All Units',
          },
        ];
      }
      return this.getUnits;
    },
  },
  props: {
    values: {
      type: Array,
      required: false,
    },
    multi: {
      type: Boolean,
      required: false,
      default: () => {
        return false;
      },
    },
    allowAll: {
      type: Boolean,
      required: false,
      default: () => {
        return false;
      },
    },
    allLabel: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    displayInline: {
      type: Boolean,
      required: false,
      default: () => {
        return false;
      },
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    maxItems: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      selectedValues: [],
      menuState: undefined,
    };
  },
  async created() {
    if (!this.multi) {
      this.selectedValues = undefined;
    }
    if (this.values) {
      if (!this.multi) {
        this.selectedValues = this.values.length ? this.values[0] : undefined;
      } else {
        this.selectedValues = this.values.slice();
      }
    }
  },
  watch: {
    values: {
      immediate: true,
      handler(n) {
        // Convert to/from array as needed
        if (!this.multi) {
          this.selectedValues = n.length ? n[0] : undefined;
        } else {
          this.selectedValues = n;
        }
      },
    },
  },
  methods: {
    doChange() {
      if (!this.multi) {
        this.$emit('update:values', [this.selectedValues]);
      } else {
        this.$emit('update:values', this.selectedValues);
      }
    },
    toggleMenu(opening) {
      if (opening) {
        return;
      }
      if (!this.multi) {
        this.$emit('change', [this.selectedValues]);
      } else {
        this.$emit('change', this.selectedValues);
      }
    },
  },
};
</script>
